import styled from "styled-components";
import { Col } from "antd";
import ScreenHelper from "components/Styled/ScreenHelper";
import { ColSize } from "antd/lib/col";

declare type ColSpanType = ColSize;

export const CheckoutCompleteLayout: { [key: string]: ColSpanType } = {
  xl: {
    span: 24,
    offset: 0,
  },
  lg: {
    span: 24,
    offset: 0,
  },
  md: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 22,
    offset: 1
  },
  xs: {
    span: 22,
    offset: 1
  }
};

export const ButtonLayout: { [key: string]: ColSpanType } = {
  xl: {
    span: 1,
    offset: 20,
  },
  lg: {
    span: 1,
    offset: 20,
  },
  md: {
    span: 1,
    offset: 20,
  },
  sm: {
    span: 1,
    offset: 14
  },
  xs: {
    span: 1,
    offset: 14
  }
};


export const CheckoutComplete = styled(Col)`
text-align: left
`;